/**
 * ルール管理ページの search parameter 定義を行う route ファイル。
 * 一覧フィルター、ページネーション、選択中 rule id を正規化します。
 */

import { Outlet, createFileRoute } from '@tanstack/react-router'

const parseNumber = ({
  value,
}: { readonly value: unknown }): number | undefined => {
  if (typeof value === 'number') {
    return Number.isNaN(value) ? undefined : value
  }

  if (typeof value !== 'string') {
    return undefined
  }

  const parsed = Number.parseInt(value, 10)
  if (Number.isNaN(parsed)) {
    return undefined
  }

  return parsed
}

const parseString = ({
  value,
}: { readonly value: unknown }): string | undefined => {
  if (typeof value !== 'string') {
    return undefined
  }
  return value
}

const parseNameOperator = ({
  value,
}: {
  readonly value: unknown
}): 'like' | 'not-like' | undefined => {
  if (value === 'like' || value === 'not-like') {
    return value
  }
  return undefined
}

export const Route = createFileRoute('/_layoutPortfolio/setting/rule')({
  validateSearch: (
    search: Record<string, unknown>,
  ): {
    rule?: number
    f_name?: string
    f_name_op?: 'like' | 'not-like'
    p?: number
    s?: number
  } => {
    return {
      rule: parseNumber({ value: search.rule }),
      f_name: parseString({ value: search.f_name }),
      f_name_op: parseNameOperator({ value: search.f_name_op }),
      p: parseNumber({ value: search.p }),
      s: parseNumber({ value: search.s }),
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <Outlet />
}
